import React from "react";

import {
  PrivacyBanner,
} from "./PrivacyBanner";


import {
  PrivacyPreferences,
} from "./PrivacyPreferences";


import {
  PrivacyAutoScripts,
} from "./PrivacyAutoScripts";



export function PrivacyManager(){


  return (

    <>

      <PrivacyAutoScripts />


      <PrivacyBanner />


      <PrivacyPreferences />


    </>

  );

}